jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })
 

  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();
  
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });
  
  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });
  
    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');
      
    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer is visible -> hide sticky form
            stickyForm.style.display = "none";
          } else {
            // Footer is not visible -> show sticky form
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0, // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);
  }
});


/* =========================================================================
   STICKY "IN DEN WARENKORB" - Varianten- und Mengenauswahl (nur mobil)
   -------------------------------------------------------------------------
   Spiegelt die Optionen (z. B. Groesse, Farbe) und die Menge aus dem
   Produktformular in die Sticky-Leiste. Aenderungen werden in das echte
   Formular zurueckgeschrieben, damit Preis, Verfuegbarkeit und Bild
   weiterhin von der Theme-Logik aktualisiert werden.
   Das bestehende Verhalten der Leiste bleibt unveraendert.
   ========================================================================= */
(function () {
  var MOBILE_MAX = 749;

  function injectStyles() {
    if (document.getElementById('sticky-atc-options-styles')) return;
    var css = [
      '.sticky-atc-options{display:none;}',
      '@media screen and (max-width:' + MOBILE_MAX + 'px){',
      '.sticky-atc-options{display:flex;flex-wrap:nowrap;align-items:center;gap:.8rem;width:100%;margin:0 0 .8rem;}',
      '.sticky-atc-options__field{flex:1 1 0;min-width:0;position:relative;}',
      '.sticky-atc-options__field select{width:100%;-webkit-appearance:none;appearance:none;padding:.9rem 2.6rem .9rem 1rem;font-size:1.4rem;line-height:1.2;border-radius:10px;border:1px solid rgba(var(--color-foreground,18 18 18),.2);background:rgb(var(--color-background,255 255 255));color:rgb(var(--color-foreground,18 18 18));}',
      '.sticky-atc-options__field:after{content:"";position:absolute;right:1.1rem;top:50%;width:.7rem;height:.7rem;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:translateY(-70%) rotate(45deg);pointer-events:none;opacity:.6;}',
      '.sticky-atc-qty{display:flex;align-items:center;flex:0 0 auto;border:1px solid rgba(var(--color-foreground,18 18 18),.2);border-radius:10px;overflow:hidden;background:rgb(var(--color-background,255 255 255));}',
      '.sticky-atc-qty button{width:3.2rem;height:4rem;border:0;background:transparent;font-size:1.7rem;line-height:1;cursor:pointer;color:inherit;padding:0;}',
      '.sticky-atc-qty button:disabled{opacity:.35;cursor:default;}',
      '.sticky-atc-qty input{width:3rem;height:4rem;border:0;text-align:center;font-size:1.4rem;background:transparent;color:inherit;-moz-appearance:textfield;padding:0;}',
      '.sticky-atc-qty input::-webkit-outer-spin-button,.sticky-atc-qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}',
      '.product-sticky-form .container{flex-wrap:wrap;}',
      '}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'sticky-atc-options-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function getMainScope() {
    return document.querySelector('.main-product__template') || document.querySelector('[id^="MainProduct-"]');
  }

  function refreshStickyPrice(scope) {
    var priceEl = scope.querySelector('.price');
    var target = document.querySelector('.product-sticky-price');
    if (priceEl && target) target.innerHTML = priceEl.innerHTML;
  }

  function buildMirrorSelect(labelText, values, currentValue, onPick) {
    var field = document.createElement('div');
    field.className = 'sticky-atc-options__field';
    var select = document.createElement('select');
    select.setAttribute('aria-label', labelText);
    values.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v.value;
      opt.textContent = labelText + ': ' + v.label;
      if (v.value === currentValue) opt.selected = true;
      if (v.disabled) opt.disabled = true;
      select.appendChild(opt);
    });
    select.addEventListener('change', function () { onPick(select.value); });
    field.appendChild(select);
    return { field: field, select: select };
  }

  function setupOptions(scope, wrap) {
    var vSelects = scope.querySelector('variant-selects');
    if (vSelects) {
      Array.prototype.forEach.call(vSelects.querySelectorAll('select'), function (orig) {
        var box = orig.closest('.product-form__input');
        var labelEl = box ? box.querySelector('label') : null;
        var labelText = labelEl ? labelEl.textContent.trim() : 'Option';
        var values = Array.prototype.map.call(orig.options, function (o) {
          return { value: o.value, label: o.textContent.trim(), disabled: o.disabled };
        });
        var m = buildMirrorSelect(labelText, values, orig.value, function (val) {
          orig.value = val;
          orig.dispatchEvent(new Event('change', { bubbles: true }));
        });
        wrap.appendChild(m.field);
        orig.addEventListener('change', function () { m.select.value = orig.value; });
      });
      return;
    }

    var vRadios = scope.querySelector('variant-radios');
    if (!vRadios) return;
    Array.prototype.forEach.call(vRadios.querySelectorAll('fieldset'), function (fs) {
      var legend = fs.querySelector('legend');
      var labelText = legend ? legend.textContent.trim() : 'Option';
      var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return;
      var checked = null;
      radios.forEach(function (r) { if (r.checked) checked = r; });
      var values = radios.map(function (r) {
        var lab = fs.querySelector('label[for="' + r.id + '"]');
        return { value: r.value, label: lab ? lab.textContent.trim() : r.value, disabled: r.disabled };
      });
      var m = buildMirrorSelect(labelText, values, checked ? checked.value : '', function (val) {
        var match = null;
        radios.forEach(function (r) { if (r.value === val) match = r; });
        if (!match) return;
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      });
      wrap.appendChild(m.field);
      radios.forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) m.select.value = r.value; });
      });
    });
  }

  function setupQuantity(scope, wrap) {
    var origQty = scope.querySelector('.product-form__quantity input.quantity__input')
      || scope.querySelector('input.quantity__input')
      || scope.querySelector('input[name="quantity"]');
    if (!origQty) return;

    var box = document.createElement('div');
    box.className = 'sticky-atc-qty';

    var minus = document.createElement('button');
    minus.type = 'button';
    var quantityControl = origQty.closest('quantity-input') || origQty.parentElement;
    var originalMinus = quantityControl.querySelector('button[name=minus]');
    minus.setAttribute('aria-label', originalMinus ? (originalMinus.getAttribute('aria-label') || originalMinus.textContent.trim()) : 'Decrease quantity');
    minus.textContent = '\u2212';

    var input = document.createElement('input');
    input.type = 'number';
    input.min = origQty.min || '1';
    input.value = origQty.value || '1';
    var quantityLabel = scope.querySelector('label[for="' + origQty.id + '"]');
    input.setAttribute('aria-label', quantityLabel ? quantityLabel.textContent.trim() : (origQty.getAttribute('aria-label') || 'Quantity'));

    var plus = document.createElement('button');
    plus.type = 'button';
    var originalPlus = quantityControl.querySelector('button[name=plus]');
    plus.setAttribute('aria-label', originalPlus ? (originalPlus.getAttribute('aria-label') || originalPlus.textContent.trim()) : 'Increase quantity');
    plus.textContent = '+';

    function push(val) {
      var min = parseInt(input.min || '1', 10);
      var v = parseInt(val, 10);
      if (isNaN(v) || v < min) v = min;
      input.value = v;
      origQty.value = v;
      origQty.dispatchEvent(new Event('change', { bubbles: true }));
      minus.disabled = v <= min;
    }

    minus.addEventListener('click', function () { push(parseInt(input.value, 10) - 1); });
    plus.addEventListener('click', function () { push(parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () { push(input.value); });
    origQty.addEventListener('change', function () {
      if (input.value !== origQty.value) input.value = origQty.value;
    });

    box.appendChild(minus);
    box.appendChild(input);
    box.appendChild(plus);
    wrap.appendChild(box);
    push(input.value);
  }

  function init() {
    var sticky = document.querySelector('product-sticky-form');
    if (!sticky) return;
    if (sticky.querySelector('.sticky-atc-options')) return;

    var scope = getMainScope();
    if (!scope) return;

    var buttonWrap = sticky.querySelector('.product-sticky-form-wrap');
    if (!buttonWrap) return;

    injectStyles();

    var wrap = document.createElement('div');
    wrap.className = 'sticky-atc-options';

    setupOptions(scope, wrap);
    setupQuantity(scope, wrap);

    if (!wrap.children.length) return;

    buttonWrap.parentNode.insertBefore(wrap, buttonWrap);

    var priceWatcher = scope.querySelector('.price');
    if (priceWatcher && window.MutationObserver) {
      new MutationObserver(function () { refreshStickyPrice(scope); })
        .observe(priceWatcher, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 200);
  });
})();


/* =========================================================================
   SUCH-PANEL: Position exakt unter der Navigationsleiste
   Setzt --search-panel-top auf die Unterkante des Headers, damit das
   Dropdown auch bei Sticky-Header und Ankuendigungsleiste korrekt sitzt.
   ========================================================================= */
(function () {
  function setSearchPanelTop() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    if (bottom < 0) bottom = 0;
    document.documentElement.style.setProperty('--search-panel-top', Math.round(bottom) + 'px');
  }

  function watchOpenState() {
    var modals = document.querySelectorAll('.header__search details');
    Array.prototype.forEach.call(modals, function (d) {
      d.addEventListener('toggle', function () {
        if (d.hasAttribute('open')) {
          setSearchPanelTop();
          var input = d.querySelector('.search__input');
          if (input) setTimeout(function () { input.focus(); }, 60);
        }
      });
    });
  }

  function init() {
    setSearchPanelTop();
    watchOpenState();
    window.addEventListener('resize', setSearchPanelTop);
    window.addEventListener('scroll', setSearchPanelTop, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 200);
  });
})();

